import Skeleton from 'react-loading-skeleton'

export function AssetPlaceholder() {
	return (
		<div className='nftBannerCnt h-100'>
			<Skeleton height='100%' />
		</div>
	)
}
